import React from 'react';
import './PlayerPage.css'; // Tell Webpack that Button.js uses these styles
import PlayerStrokeItem from './PlayerStrokeItem.js';
import * as Constants from '../../Common/constants.js';
import * as Utils from '../../Common/utils.js';
export default class Player extends React.Component {

    constructor(props) {

        super(props);

        this.state = {};

        console.info('Player - constructor called.');
    }
    static getDerivedStateFromProps(props, state) {
        console.info('Player - getDerivedStateFromProps called.');
        return state;
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        console.info('Player - getSnapshotBeforeUpdate called.');
        return null;
    }



    componentDidMount() {
        console.info('Player - componentDidMount called.');

    }



    shouldComponentUpdate() {
        console.info('Player - shouldComponentUpdate.');
        return true;
    }


    componentDidUpdate() {
    }

    componentWillUnmount() {

    }



    render() {
        console.info('Player - render called.', this.props.data);
       
        return (
            <div >

                {this.renderPlayerInfo()}

                {this.renderPlayerEvents()}


            </div>);


    }
    renderPlayerInfo() {
        return (<div className="playerheader">
            <div className="playername" style={{ backgroundColor: this.props.data.color }}>{this.props.data.name}</div><div className="playerinfo"></div>
        </div>);

    }

    renderPlayerEvents() {
        var events = [];

        let holeindex = Utils.getHoleIndex(this.props.data);
        if (this.props.data.events) {
            events = this.props.data.events;
        }

        let lastid = events.length > 0 ? events[events.length - 1].id : -1;


        let scoutevents = this.props.leaderboard.leaderboard ? this.props.leaderboard.leaderboard.events : null;
        if (scoutevents) {
            scoutevents.forEach(element => {
                if ("" +element.holeIndex === holeindex && element.playerId === this.props.data.id &&
                    element.id > lastid) {
                    events.push(element);
                }
            });
        }

        this.props.data.events = events;
        let items = [];

        if (!events || events.length == 0) {
            items.push(<PlayerStrokeItem data={null} key={0} />);
            return items;
        }
        var lastEventPerStroke = new Object();
        var mapStrokeIndex = 1;
        events.forEach(element => {
            lastEventPerStroke[element.strokeIndex] = element;
            mapStrokeIndex = element.strokeIndex;
        });

        for (let index = 1; index <= mapStrokeIndex; index++) {
            const element = lastEventPerStroke[index];
            items.push(<PlayerStrokeItem data={element} key={index} />);
        }

        return items;
    }
    renderPlayerStrokesInfo() {
        let items = this.renderCurrentHoleStrokeItems();

        return (<div>
            {items}
        </div>
        );
    }

    renderCurrentHoleStrokeItems() {
        let array = [];
        let currentholeevents = [];
        let maxstrokeindex = 0;
        let currenthole = this.props.data.currenthole;
        let mapStrokeIndex = new Object();
        this.props.data.events.forEach(e => {
            if (e.holeindex === currenthole) {

                currentholeevents.push(e);
                maxstrokeindex = Math.max(e.strokeindex, maxstrokeindex);

                var a = mapStrokeIndex[e.strokeindex];

                if (!a) {
                    a = [];
                }

                a.push(e);

                mapStrokeIndex[e.strokeindex] = a;

            }
        });

        for (let index = 0; index < maxstrokeindex; index++) {

            const a = mapStrokeIndex[index + 1];
            array.push(<PlayerStrokeItem data={a} key={index} />);

        }

        if (currentholeevents.length === 0) {
            array.push(<PlayerStrokeItem key={0} />);
        }

        return array;
    }
    getCurrentStrokeData() {
        var currentstroke = new Object();
        currentstroke.index = 1;
        currentstroke.status = "Preparing to hit";
        return currentstroke;
    }





}





// WEBPACK FOOTER //
// ./src/Components/PlayerPage/Player.js